export default {
	title: 'Device Image',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete',
		save: 'Save',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Operation successful',
		selectDeleteWarning: 'Please select the records to delete',
		operateSuccess: 'Operation successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		imageFormatError: 'Only JPG/PNG format images are allowed!',
		imageSizeError: 'Image size cannot exceed 10MB!',
		uploadSuccess: 'Image uploaded successfully',
		uploadError: 'Image upload failed',
		addSensorSuccess: 'Successfully added {count} sensors',
		updateSensorSuccess: 'Successfully updated {count} sensors',
		noValidSensor: 'Please fill in at least one complete sensor information',
		duplicateSensorName: 'The following sensor names already exist: {names}'
	},
	form: {
		deviceTypeId: 'Device Type',
		placeholder: {
			deviceTypeId: 'Please select device type'
		}
	},
	table: {
		id: 'ID',
		name: 'Solution Name',
		deviceTypeId: 'Device Type',
		sensorNumber: 'Sensor Count',
		filePath: 'Device Image'
	},
	widgetForm: {
		deviceTypeId: 'Device Type',
		deviceImage: 'Device Image',
		gridLayout: 'Grid Layout',
		placeholder: {
			deviceTypeId: 'Please select device type'
		}
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm',
		batchAddSensor: 'Batch Add Sensors'
	},
	labels: {
		solutionName: 'Solution Name',
		deviceType: 'Device Type',
		deviceImage: 'Device Image',
		isDefault: 'Is Default',
		yes: 'Yes',
		no: 'No',
		sensorName: 'Sensor Name',
		partName: 'Part Name',
		serialNumber: 'Serial Number',
		addSensor: 'Add Sensor',
		addSensorRow: 'Add Sensor Row',
		operation: 'Operation'
	}
}
